export default __webpack_public_path__ + "328f2b0b505a54b1ba8bf7d297ea2ec1.png";